import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const PostsPage = () => {
    const [posts, setPosts] = useState([]);
    const [error, setError] = useState('');
    const ws = useRef(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/posts`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPosts(response.data);
            } catch (err) {
                setError('Failed to fetch posts');
            }
        };

        fetchPosts();

        if (!ws.current) {
            ws.current = new WebSocket(`ws://127.0.0.1:8000/ws/admin/posts`);

            ws.current.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.event === 'new_post') {
                    setPosts((prevPosts) => [data.post, ...prevPosts]);
                } else if (data.event === 'updated_post') {
                    setPosts((prevPosts) =>
                        prevPosts.map((p) => (p.id === data.post.id ? data.post : p))
                    );
                } else if (data.event === 'deleted_post') {
                    setPosts((prevPosts) => prevPosts.filter((p) => p.id !== data.post_id));
                }
            };
        }

        return () => {
            if (ws.current) {
                ws.current.close();
                ws.current = null;
            }
        };
    }, []);

    const handleDelete = async (postId) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/admin/posts/${postId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // No need to call fetchPosts() anymore, the WebSocket will handle the update
        } catch (err) {
            setError('Failed to delete post');
        }
    };

    if (error) {
        return <div className="text-red-500">{error}</div>;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl lg:text-3xl font-bold text-slate-900">Posts Management</h1>
                <p className="text-slate-500 mt-1">View and manage all posts on the platform ({posts.length} total)</p>
            </div>
            
            <div className="card overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr>
                                <th className="text-left" style={{ width: '40%' }}>Content</th>
                                <th className="text-left" style={{ width: '20%' }}>Image</th>
                                <th className="text-left" style={{ width: '20%' }}>Author</th>
                                <th className="text-center" style={{ width: '20%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {posts.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center py-8 text-slate-500">
                                        No posts found
                                    </td>
                                </tr>
                            ) : (
                                posts.map((post) => (
                                    <tr key={post.id || post._id}>
                                        <td>
                                            <p className="font-medium text-slate-900">{post.content.substring(0, 80)}</p>
                                            <p className="text-xs text-slate-500 mt-1">
                                                {new Date(post.created_at).toLocaleDateString()}
                                            </p>
                                        </td>
                                        <td>
                                            {post.image_url ? (
                                                <img src={post.image_url} alt="Post preview" className="h-12 w-12 rounded object-cover" />
                                            ) : (
                                                <span className="text-slate-400 text-sm">No image</span>
                                            )}
                                        </td>
                                        <td>
                                            <p className="font-medium text-slate-900">{post.author_name}</p>
                                        </td>
                                        <td className="text-center">
                                            <button 
                                                onClick={() => handleDelete(post.id || post._id)} 
                                                className="px-3 py-2 text-xs font-medium text-white bg-red-500 rounded-md hover:bg-red-600 transition-colors"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PostsPage;